import { Box, Card } from "@mui/material";
import ClearwaysDeviceSettings from "components/Forms/ClearwaysDeviceSettings";
import DeviceSettingsForm from "components/Forms/DeviceSettings";
import { useSoftUIController } from "hooks/context";
import PropTypes from "prop-types";

function DeviceSettingsTab({ uuid, device, tags, raw_device }) {

    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    return (
        <Card sx={{ height: "100%", minHeight: deviceLayout == 'mobile' ? 'calc(100svh - 8.5rem - 16px)' : '100%', overflowY: 'auto' }}>
            {device.organisation_id == 'clearways' ? (
                <ClearwaysDeviceSettings uuid={uuid} selected_device={raw_device} />
            ) : (
                <DeviceSettingsForm selected_device={device} tags={tags} />
            )}
        </Card>
    );
}

DeviceSettingsTab.propTypes = {
    uuid: PropTypes.string,
    device: PropTypes.object,
    tags: PropTypes.object,
    raw_device: PropTypes.object
}

export default DeviceSettingsTab;